"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpErrorStatus = httpErrorStatus;
/**
 * The HTTP status carried by an error thrown by EITHER app's API client, or
 * undefined when the error carries none (a network failure, a plain Error).
 *
 * THE TWO CLIENTS PUT THE STATUS IN DIFFERENT PLACES, AND THIS READS BOTH ON
 * PURPOSE. Do not "tidy" it down to one shape:
 *
 * - Web (`frontend/src/api/client.ts`) is axios. An `AxiosError` keeps the
 *   status at `err.response.status`.
 * - Mobile (`mobile/src/api/client.ts`) is fetch. It throws `ApiClientError`,
 *   which keeps the status at `err.status` and has no `response` at all.
 *
 * Reading only one shape does not fail loudly. It returns undefined for the
 * other client's errors, so every status-dependent branch in that app quietly
 * takes its default path. That is how BEN-141 MRT-004 happened: mobile's
 * "deactivate a bank-detected row when DELETE is refused" fallback copied web's
 * `err.response.status`, never matched, and no detected bill or income could be
 * removed on mobile. `forecastFailureKind` below had the same one-shape read, so
 * mobile reported a refused forecast (400) as a failed request.
 *
 * Both shapes are covered by tests in both apps: web's `finishSetup.test.tsx`
 * (a real AxiosError) and mobile's `setupForecastOutcome.test.tsx` and
 * `removeRecurring.test.ts` (a real ApiClientError). If you change this, run both.
 */
function httpErrorStatus(err) {
    if (err == null || typeof err !== "object")
        return undefined;
    const e = err;
    // Mobile's ApiClientError.
    if (typeof e.status === "number")
        return e.status;
    // Web's AxiosError.
    if (typeof e.response?.status === "number")
        return e.response.status;
    return undefined;
}
//# sourceMappingURL=httpStatus.js.map